"use client";
import { UserDto } from "@rinastyling/common";
import { useSetAtom } from "jotai";
import { useEffect } from "react";
import { isMobileAtom } from "../store/layoutStore";
import { userAtom } from "../store/userAtom";

const SetServerSSRToAtom = ({
  isMobile,
  user
}: {
  isMobile: boolean;
  user: {
    user: UserDto;
    accessToken: string;
  } | null;
}) => {
  const setIsMobile = useSetAtom(isMobileAtom);
  const setUser = useSetAtom(userAtom);

  useEffect(() => {
    setIsMobile(isMobile);
    if (user) {
      setUser({ ...user.user, accessToken: user.accessToken });
    }
  }, [isMobile, setIsMobile, setUser, user]);

  return null;
};

export default SetServerSSRToAtom;
